import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment';
import React, { useState } from 'react';
import { MomentDocs } from '../../components/MomentDocs';

export const HomePage = () => {
  const [format, setFormat] = useState('DD/MM/yyyy [at] hh:mm a Z');

  return (
    <div className="m-4 text-white">
      <h1>Format Dates</h1>
      <div className="row">
        <label
          htmlFor="format"
          className="col-2 col-form-label"
        >Format string</label>
        <input
          id="format"
          type="text"
          className="col-4 form-control mb-2"
          value={format}
          onChange={e => setFormat(e.target.value)}
        />
      </div>

      <div>{'Formatted: ' + moment().format(format)}</div>
      <div>{'ISO: ' + moment().format()}</div>
      <MomentDocs />
    </div>
  );
};